/**
 * Screenshot assets and editorial review date shared by the English and
 * Bengali case-study detail pages. Case data refers to images by key
 * (e.g. "danse-evasion-1"); resolveCaseImage maps a key to the bundled file.
 */
import danseEvasion1 from "@/assets/danse-evasion-1.webp";
import danseEvasion2 from "@/assets/danse-evasion-2.webp";
import cbdKeywords1 from "@/assets/cbd-keywords-1.webp";
import cbdKeywords2 from "@/assets/cbd-keywords-2.webp";
import danceamor1 from "@/assets/danceamor-1.webp";
import danceamor2 from "@/assets/danceamor-2.webp";

const CASE_IMAGES: Record<string, string> = {
  "danse-evasion-1": danseEvasion1,
  "danse-evasion-2": danseEvasion2,
  "cbd-keywords-1": cbdKeywords1,
  "cbd-keywords-2": cbdKeywords2,
  "danceamor-1": danceamor1,
  "danceamor-2": danceamor2,
};

/** Bundled file for a case image key; unknown keys are treated as URLs. */
export function resolveCaseImage(src: string): string {
  return CASE_IMAGES[src] ?? src;
}

/** Editorial review date for case-study Article schema (both languages).
 *  Bump when the underlying case-study copy changes. */
export const CASE_STUDY_REVIEWED_ON = "2026-10-31";
